import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IRadio } from 'codex-lib';

@Component({
  selector: 'app-confirm-radio',
  templateUrl: './confirm-radio.component.html',
  styleUrls: ['./confirm-radio.component.scss']
})
export class ConfirmRadioComponent implements OnInit {

  @Output() onChange = new EventEmitter();
  @Input() defaultValue: boolean;
  @Input() title: String;
  radioYes: IRadio;
  radioNo: IRadio;
  checkedState = true;

  constructor() { }

  ngOnInit() {
    this.radioYes ={
      span: "yes",
    }

    this.radioNo = {
      span: "no",
    }
  }
  changeYes(value) {
    if(value == true){
      this.checkedState = true;
      this.onChange.emit(value);
    }
  }
  changeNo(value) {
    if(value == true){
      this.checkedState = false;
      this.onChange.emit(!value);
    }
  }

}